export type FileValidationResponseObject = {
  unsupportedFileType: boolean;
  maxFileSizeExceeded: boolean;
  passwordProtected: boolean;
  maxFileSizeExceededIndex: number[];
};

export class FileValidationResponse {
  unsupportedFileType: boolean;
  maxFileSizeExceeded: boolean;
  maxFileSizeExceededIndex: number[];

  constructor(fileValidationResponse?: Partial<FileValidationResponseObject>) {
    this.unsupportedFileType = fileValidationResponse?.unsupportedFileType ?? false;
    this.maxFileSizeExceeded = fileValidationResponse?.maxFileSizeExceeded ?? false;
    this.maxFileSizeExceededIndex = fileValidationResponse?.maxFileSizeExceededIndex ?? [];
  }

  isValid(): boolean {
    return !this.unsupportedFileType && !this.maxFileSizeExceeded;
  }
}
